// /role/list
import axios from './../api' // 倒入 api

//获取角色列表
const getRoleList = (data) => {
  return axios({
    url: '/api/role/list',
    method: 'POST',
    data,
  })
}

//获取角色关联的用户
const getRoleUser = (params) => {
  return axios({
    url: '/api/user/role/list',
    method: 'GET',
    params,
  })
}

//获取用户列表（分页）
const getUserList = (data) => {
  return axios({
    url: '/api/user/list',
    method: 'POST',
    data,
  })
}

//新增用户
const addUser = (data) => {
  return axios({
    url: '/api/user',
    method: 'POST',
    data,
  })
}

//修改用户
const modifyUser = (data) => {
  return axios({
    url: '/api/user',
    method: 'PUT',
    data,
  })
}

//删除用户
const delUser = (roleId) => {
  return axios({
    url: `/api/user/${roleId}`,
    method: 'DELETE',
  })
}
//禁用用户
const channgeUserStatus = (userId) => {
  return axios({
    url: `/api/user/status/${userId}`,
    method: 'PUT',
  })
}

//重置密码
const resetUsrPwd = (params) => {
  return axios({
    url: '/api/user/psw/reset',
    method: 'PUT',
    params,
  })
}

// 用户详情
export const getUserDetail = (userId) => {
  return axios({
    url: `/api/user/${userId}`,
    method: 'GET',
  })
}

//修改角色绑定的用户
const modifyRoleUser = (data) => {
  return axios({
    url: '/api/role/user',
    method: 'PUT',
    data,
  })
}

//获取全部组织列表
const getAllOrg = () => {
  return axios({
    url: '/api/org/list',
    method: 'GET',
  })
}

//获取组织下的车辆列表
const getOrgCars = (orgId) => {
  return axios({
    url: `/api/car/simple/org/${orgId}`,
    method: 'GET',
  })
}

//获取组织树
const getOrgTree = () => {
  return axios({
    url: '/api/org/tree',
    method: 'GET',
  })
}
//获取组织树
const getPosOrgTree = () => {
  return axios({
    url: '/api/location/org/tree',
    method: 'GET',
  })
}

//新增组织
const addOrg = (data) => {
  return axios({
    url: '/api/org',
    method: 'POST',
    data,
  })
}

//修改组织
const modifyOrg = (data) => {
  return axios({
    url: '/api/org',
    method: 'PUT',
    data,
  })
}

//删除组织
const delOrg = (orgId) => {
  return axios({
    url: `/api/org/${orgId}`,
    method: 'DELETE',
  })
}

//获取角色菜单树
const getAuthTree = (params) => {
  return axios({
    url: '/api/auth/menu/rolemenu',
    method: 'GET',
    params,
  })
}

//获取全局菜单树
const getMenuTree = () => {
  return axios({
    url: '/api/auth/role/menu',
    method: 'GET',
  })
}

//修改角色菜单树
const modifyAuthMenu = (data) => {
  return axios({
    url: '/api/role/menu',
    method: 'PUT',
    data,
  })
}

//查询角色的菜单ID
const getRolemenuids = (params) => {
  return axios({
    url: '/api/auth/menu/rolemenuids',
    method: 'GET',
    params,
  })
}

//新建角色
const addRole = (data) => {
  return axios({
    url: '/api/role',
    method: 'POST',
    data,
  })
}

//修改角色
const modifyRole = (data) => {
  return axios({
    url: '/api/role',
    method: 'PUT',
    data,
  })
}

//删除角色
const delRole = (roleId) => {
  return axios({
    url: `/api/role/${roleId}`,
    method: 'DELETE',
  })
}

const roleDetail = (roleId) => {
  return axios({
    url: `/api/role/${roleId}`,
    method: 'GET',
  })
}

const getAllMenu = () => {
  return axios({
    url: `/api/auth/menu/list`,
    method: 'GET',
  })
}

const getOffAllMenu = () => {
  return axios({
    url: `/api/auth/menu`,
    method: 'GET',
  })
}

//流程列表
const getFlowroute = () => {
  return axios({
    url: `/api/flowroute/list`,
    method: 'GET',
  })
}

//流程禁用
const closeFlowroute = (routeId) => {
  return axios({
    url: `/api/flowroute/${routeId}`,
    method: 'PUT',
  })
}

//流程详情
const flowrouteDetail = () => {
  return axios({
    url: `/api/flowroute`,
    method: 'GET',
  })
}

//流程节点详情
const flowrouteNodeDetail = (nodeId) => {
  return axios({
    url: `/api/flownode/${nodeId}`,
    method: 'GET',
  })
}

//流程审批节点编辑
const modifyFlowroute = (params) => {
  return axios({
    url: `/api/flownode`,
    method: 'PUT',
    params,
  })
}
// * 流程
//流程审批节点编辑
const getFlownode = (flowType, orgId) => {
  return axios({
    url: `/api/flowroute`,
    params: {
      flowType,
      orgId,
    },
  })
}
//流程审批节点编辑
const modifyFlowrouteNode = (data) => {
  return axios({
    url: `/api/flownode`,
    method: 'POST',
    data,
  })
}

//流程审批节点编辑
const plcFlowPatch = (tenantIds, orgId) => {
  console.log('orgId', orgId)
  return axios({
    url: `/api/plc/flow/patch`,
    params: {
      tenantIds,
      orgId,
    },
  })
}

//流程审批节点编辑
const editFlownode = (params) => {
  return axios({
    url: `/api/flownode`,
    method: 'PUT',
    params,
  })
}

//流程节点启用禁用
const switchFlowroute = (routeId) => {
  return axios({
    url: `/api/flowroute/${routeId}`,
    method: 'PUT',
  })
}
//用车设置流程设置
const flowSet = (orgId) => {
  return axios({
    url: `/api/query-flow-set`,
    params: {
      orgId,
    },
  })
}
//提交用车设置流程设置
const editFlowSet = (data) => {
  return axios({
    url: `/api/edit-flow-set`,
    method: 'POST',
    data,
  })
}
//获取流程节点
const getFlowRoute = (params) => {
  return axios({
    url: `/api/flowroute`,
    params,
  })
}
//用户操作日志
const operationLog = (data) => {
  return axios({
    url: `/api/operation/log`,
    method: 'POST',
    data,
  })
}
// 默认全部倒出
// 根绝需要进行
export default {
  modifyFlowrouteNode,
  getFlowRoute,
  editFlowSet,
  flowSet,
  getRoleList,
  getRoleUser,
  getUserList,
  getAllOrg,
  getOrgTree,
  getPosOrgTree,
  addOrg,
  modifyOrg,
  delOrg,
  addUser,
  modifyUser,
  channgeUserStatus,
  resetUsrPwd,
  modifyRoleUser,
  getAuthTree,
  getMenuTree,
  modifyAuthMenu,
  getRolemenuids,
  addRole,
  modifyRole,
  delRole,
  roleDetail,
  delUser,
  getUserDetail,
  getFlowroute,
  closeFlowroute,
  flowrouteDetail,
  flowrouteNodeDetail,
  modifyFlowroute,
  getOrgCars,
  getFlownode,
  plcFlowPatch,
  editFlownode,
  switchFlowroute,
  operationLog,
}
